import React, { Component } from 'react';
import ReactTable from 'react-table';
import {
  faEdit,
  faPlus,
  faArrowLeft,
  faRepeat,
} from '@fortawesome/pro-regular-svg-icons';
import Loader from '../../../../../components/Loader';
import Button from '../../../../../components/Button';
import settings from '../../../../../../settings';
import DataContainer from '../../../../../logic/dataContainer';
import { Link, NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';
import getConstants from '../../../../../logic/constants';
import api from '../../../../../logic/api';
import HeaderbarButton from '../../../../../components/HeaderbarButton';

class MediationOverview extends Component {
  constructor(props) {
    super(props);
    this.guid = this.props.match.params.guid;
    this.parentRoute = this.props.match.url.replace(
      new RegExp('/mediation/.*'),
      '',
    );

    this.state = {
      loading: true,
      data: [],
      CarePsych: [],
    };
    this.initConstants();
  }

  async initConstants() {
    this.setState({
      CarePsych: await getConstants('CarePsych'),
    });
  }

  loadData = () => {
    this.setState({
      loading: true,
    });
    const dataColumns = {
      Type: 'Mediation',
      AmbPsyGuid: this.guid,
    };
    api('get', settings.clientmanagement.dataContainer.getList, {
      parameter: JSON.stringify(dataColumns),
    })
      .then((res) => {
        const filteredClientData = new DataContainer(res);
        this.setState({
          data: filteredClientData.getMany('Entry'),
          loading: false,
        });
      })
      .catch(() => {
        this.setState({
          loading: false,
        });
      });
  };

  componentDidMount() {
    this.loadData();
  }

  render() {
    if (this.state.loading) {
      return (
        <div>
          <Loader text="Vermittlungen werden geladen..." />
        </div>
      );
    }

    let data = [];
    if (
      this.state.data.filter((entry) => {
        return entry.Guid;
      }).length
    ) {
      data = this.state.data;
    }

    return (
      <>
        <div className="Headerbar sticky">
          <div className="Headerbar-breadcrumbs">
            Versorgungsnetzwerk -{' '}
            <Link to="/supplynetwork/AmbulatoryPsychotherapy">
              Ambulante Psychotherapie
            </Link>{' '}
            - <b>Vermittlungen</b>
          </div>
          <div className="Headerbar-buttons">
            <HeaderbarButton icon={faRepeat} onClick={this.loadData}>
              Liste aktualisieren
            </HeaderbarButton>
          </div>
        </div>

        <div className="Split-Panes-Menu">
          <div className="Split-Pane-Menu">
            <div className="Split-Pane-Menu-Nav">
              <NavLink
                className="FormArea-Body-Tab"
                to={`/supplynetwork/AmbulatoryPsychotherapy`}
              >
                <FontAwesomeIcon icon={faArrowLeft} /> Zurück zur Übersicht
              </NavLink>
              <NavLink
                to={`${this.parentRoute}/${this.guid}`}
                className="FormArea-Body-Tab"
                activeClassName="is-Active"
              >
                Grunddaten
              </NavLink>
              <NavLink
                to={`${this.parentRoute}/resubmission/${this.guid}`}
                className="FormArea-Body-Tab"
                activeClassName="is-Active"
              >
                Wiedervorlage
              </NavLink>
              <NavLink
                to={`${this.parentRoute}/mediation/${this.guid}`}
                className="FormArea-Body-Tab"
                activeClassName="is-Active"
              >
                Vermittlungen
              </NavLink>
            </div>
          </div>
          <div className="Split-Pane-Main">
            <div className="Page-Content">
              <div className="Buttonbar">
                <Button
                  icon={faPlus}
                  to={`${this.parentRoute}/mediation/new/${this.guid}`}
                  replace
                >
                  Neue Vermittlung anlegen
                </Button>
              </div>
              <ReactTable
                getTrProps={(_, val) => {
                  return {
                    onClick: () => {
                      return this.props.history.push(
                        `/supplynetwork/AmbulatoryPsychotherapy/detail/mediation/detail/${val?.original?.Guid}/${this.guid}`,
                      );
                    },
                  };
                }}
                defaultSorted={[
                  {
                    id: 'UpdateUserName',
                    desc: true,
                  },
                ]}
                data={data}
                pageSize={data.length}
                noDataText="Es wurden keine Vermittlungen gefunden."
                columns={[
                  {
                    accessor: 'Date',
                    Header: 'Datum',
                    Cell: ({ original }) => {
                      return <>{moment(original.Date).format('DD.MM.YYYY')}</>;
                    },
                  },
                  {
                    accessor: 'CarePsych',
                    Header: 'CARE-Psych.',
                    Cell: ({ original }) => {
                      return (
                        <>
                          {
                            this.state.CarePsych.find((elem) => {
                              return elem.value === original.CarePsych;
                            })?.label
                          }
                        </>
                      );
                    },
                  },
                  {
                    accessor: 'Link',
                    Header: 'Zur Detailansicht',
                    Cell: () => {
                      return (
                        <>
                          <u>Hier klicken</u>&nbsp;
                          <FontAwesomeIcon icon={faEdit} />
                        </>
                      );
                    },
                  },
                ]}
              />
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default MediationOverview;
